@if (!isRequestResponse) {
  <ul>
    @for (webSocket of webSockets$ | async; track webSocket.name) {
      <li>
        <div class="dot" [style.background-color]="connectionStateColors.get(webSocket.hubConnection.state)"></div>
        <span class="socket-name">{{ 'sockets.' + webSocket.name | translate }}</span>
        <span class="socket-status">{{ 'sockets.status.' + webSocket.hubConnection.state | translate }}</span>
        @if (webSocket.hubConnection.state !== HubConnectionState.Connected && webSocket.hubConnection.state !== HubConnectionState.Disconnected) {
          <mat-spinner
            [diameter]="20">
          </mat-spinner>
        }
        @if (webSocket.hubConnection.state === HubConnectionState.Disconnected) {
          <button mat-stroked-button color="primary"
            class="connect-button"
            preventDefault
            (click)="webSocket.hubConnection.start()">
            {{ 'sockets.connect' | translate }}
          </button>
        }
        @if (webSocket.hubConnection.state !== HubConnectionState.Connected && webSocket.hubConnection.state !== HubConnectionState.Disconnected) {
          <button mat-stroked-button color="primary"
            class="connect-button"
            preventDefault
            (click)="restartSocket(webSocket)">
            {{ 'sockets.connect' | translate }}
          </button>
        }
      </li>
    }
  </ul>
} @else {
  <div class="ps-3 pe-3 pb-3">
    {{"sockets.isRequestResponse" | translate}}
  </div>
}

